/**
 * Workflow GraphQL Queries
 */

export const GET_WORKFLOWS_DASHBOARD = `
  query GetWorkflowsDashboard($offset: Int!, $limit: Int!) {
    pep_vw_workflow_dashboard(offset: $offset, limit: $limit, order_by: { workflow_id: desc }) {
      workflow_id
      workflow_name
      program_type
      assigned_user_type
      assigned_user_group_id
    }
  }
`;

export const SEARCH_WORKFLOWS_DASHBOARD = `
  query SearchWorkflowsDashboard($searchValue: String!, $filterType: String!, $offset: Int!, $limit: Int!) {
    pep_vw_workflow_dashboard(
      where: {
        _or: [
          { workflow_name: { _ilike: $searchValue } }
          { assigned_user_group_id: { _eq: $searchValue } }
        ]
      }
      offset: $offset
      limit: $limit
      order_by: { workflow_id: desc }
    ) {
      workflow_id
      workflow_name
      program_type
      assigned_user_type
      assigned_user_group_id
    }
  }
`;

export const SEARCH_WORKFLOWS_DASHBOARD_BY_PROGRAM = `
  query SearchWorkflowsDashboardByProgram($searchValue: String!, $offset: Int!, $limit: Int!) {
    pep_vw_workflow_dashboard(
      where: {
        program_type: { _contains: [$searchValue] }
      }
      offset: $offset
      limit: $limit
      order_by: { workflow_id: desc }
    ) {
      workflow_id
      workflow_name
      program_type
      assigned_user_type
      assigned_user_group_id
    }
  }
`;

export const SEARCH_WORKFLOWS_DASHBOARD_BY_USER_GROUP = `
  query SearchWorkflowsDashboardByUserGroup($userGroupId: Int!, $offset: Int!, $limit: Int!) {
    pep_vw_workflow_dashboard(
      where: {
        assigned_user_group_id: { _eq: $userGroupId }
      }
      offset: $offset
      limit: $limit
      order_by: { workflow_id: desc }
    ) {
      workflow_id
      workflow_name
      program_type
      assigned_user_type
      assigned_user_group_id
    }
  }
`;

export const SEARCH_WORKFLOWS_DASHBOARD_BY_USER_GROUPS = `
  query SearchWorkflowsDashboardByUserGroups($userGroupIds: [Int!]!, $offset: Int!, $limit: Int!) {
    pep_vw_workflow_dashboard(
      where: {
        assigned_user_group_id: { _in: $userGroupIds }
      }
      offset: $offset
      limit: $limit
      order_by: { workflow_id: desc }
    ) {
      workflow_id
      workflow_name
      program_type
      assigned_user_type
      assigned_user_group_id
    }
  }
`;

export const GET_TASKS_DASHBOARD = `
  query GetTasksDashboard($offset: Int!, $limit: Int!) {
    pep_v2_task(offset: $offset, limit: $limit, order_by: { task_id: desc }) {
      task_id
      task_name
    }
  }
`;

export const SEARCH_TASKS_DASHBOARD = `
  query SearchTasksDashboard($searchValue: String!, $offset: Int!, $limit: Int!) {
    pep_v2_task(
      where: {
        task_name: { _ilike: $searchValue }
      }
      offset: $offset
      limit: $limit
      order_by: { task_id: desc }
    ) {
      task_id
      task_name
    }
  }
`;

export const GET_WORKFLOW_STATUSES_DASHBOARD = `
  query GetWorkflowStatusesDashboard($offset: Int!, $limit: Int!) {
    pep_workflow_status(offset: $offset, limit: $limit, order_by: { created_datetime: desc }, where: { is_deleted: { _eq: false } }) {
      workflow_status_id
      workflow_status
      created_datetime
    }
  }
`;

export const SEARCH_WORKFLOW_STATUSES_DASHBOARD = `
  query SearchWorkflowStatusesDashboard($searchValue: String!, $offset: Int!, $limit: Int!) {
    pep_workflow_status(
      where: {
        _and: [
          { workflow_status: { _ilike: $searchValue } },
          { is_deleted: { _eq: false } }
        ]
      }
      offset: $offset
      limit: $limit
      order_by: { created_datetime: desc }
    ) {
      workflow_status_id
      workflow_status
      created_datetime
    }
  }
`;

export const GET_WORKFLOW_STATUS_BY_ID = `
  query GetWorkflowStatusById($id: Int!) {
    pep_workflow_status(where: { workflow_status_id: { _eq: $id } }) {
      workflow_status_id
      workflow_status
      created_datetime
    }
  }
`;

export const GET_PROGRAM_TYPES = `
  query GetProgramTypes {
    pep_program_type {
      program_type
      program_type_id
    }
  }
`;

export const GET_ALL_WORKFLOWS_FOR_DROPDOWN = `
  query GetAllWorkflowsForDropdown {
    pep_vw_workflow_dashboard {
      assigned_user_type
      program_type
      workflow_name
      workflow_id
    }
  }
`;

export const GET_ALL_TASKS_FOR_DROPDOWN = `
  query GetAllTasksForDropdown {
    pep_v2_task(order_by: { task_id: desc }) {
      task_id
      task_name
    }
  }
`;

export const GET_ALL_WORKFLOW_STATUSES_FOR_DROPDOWN = `
  query GetAllWorkflowStatusesForDropdown {
    pep_workflow_status(order_by: { created_datetime: desc }, where: { is_deleted: { _eq: false } }) {
      workflow_status_id
      workflow_status
      created_datetime
    }
  }
`;

export const GET_USER_ROLES = `
  query GetUserRoles {
    reference_user_role {
      role
      role_id
    }
  }
`;

export const GET_PROGRAM_TYPE_STATUSES = `
  query GetProgramTypeStatuses {
    pep_vw_program_type_status {
      program_status
      program_status_mapper_id
      program_type
    }
  }
`;

export const GET_WORKFLOW_PROGRAM_TYPE_IDS = `
  query GetWorkflowProgramTypeIds($workflowId: Int!) {
    pep_workflow_program_type_mapper(
      where: {workflow_id: {_eq: $workflowId}, is_deleted: {_eq: false}}
    ) {
      program_type_id
    }
  }
`;

export const GET_PROGRAM_TYPE_STATUSES_BY_IDS = `
  query GetProgramTypeStatusesByIds($programTypeIds: [Int!]!) {
    pep_vw_program_type_status(
      where: {program_type_id: {_in: $programTypeIds}}
    ) {
      program_status
      program_type
      program_status_mapper_id
      program_type_id
    }
  }
`;

export const GET_PROGRAM_TYPE_DASHBOARD = `
  query GetProgramTypeDashboard {
    pep_vw_program_type_dashboard {
      program_type
    }
  }
`;

export const GET_WORKFLOW_AUDIT_LOG = `
  query GetWorkflowAuditLog($workflowId: Int!) {
    pep_workflow_audit_log(where: {workflow_id: {_eq: $workflowId}}, order_by: {action_datetime: desc}) {
      pep_workflow_audit_log_id
      workflow_id
      action_type
      action_datetime
      action_by
      workflow_data
      metadata
      triggers
    }
    pep_workflow_audit_log_aggregate(where: {workflow_id: {_eq: $workflowId}}) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_PROGRAM_STATUS_AUDIT_LOG = `
  query GetProgramStatusAuditLog($entityId: Int!) {
    pep_state_status_audit_log(
      where: { entity_type: { _eq: "PROGRAM_STATUS" }, entity_id: { _eq: $entityId } }
      order_by: { request_id: desc }
    ) {
      entity_id
      metadata
      request_id
    }
    pep_state_status_audit_log_aggregate(
      where: { entity_type: { _eq: "PROGRAM_STATUS" }, entity_id: { _eq: $entityId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_PROGRAM_TYPE_AUDIT_LOG = `
  query GetProgramTypeAuditLog($entityId: Int!) {
    pep_state_status_audit_log(
      where: { entity_type: { _eq: "PROGRAM_TYPE_WITH_STATUS" }, entity_id: { _eq: $entityId } }
      order_by: { request_id: desc }
    ) {
      entity_id
      metadata
      request_id
    }
    pep_state_status_audit_log_aggregate(
      where: { entity_type: { _eq: "PROGRAM_TYPE_WITH_STATUS" }, entity_id: { _eq: $entityId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_WORKFLOW_STATUS_AUDIT_LOG = `
  query GetWorkflowStatusAuditLog($entityId: Int!) {
    pep_state_status_audit_log(
      where: { entity_type: { _eq: "WORKFLOW_STATUS" }, entity_id: { _eq: $entityId } }
      order_by: { request_id: asc }
    ) {
      entity_id
      metadata
      request_id
    }
    pep_state_status_audit_log_aggregate(
      where: { entity_type: { _eq: "WORKFLOW_STATUS" }, entity_id: { _eq: $entityId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_TASK_AUDIT_LOG = `
  query GetTaskAuditLog($entityId: Int!) {
    pep_state_status_audit_log(
      where: { entity_type: { _eq: "V2_TASK" }, entity_id: { _eq: $entityId } }
      order_by: { request_id: desc }
    ) {
      entity_id
      metadata
      request_id
    }
    pep_state_status_audit_log_aggregate(
      where: { entity_type: { _eq: "V2_TASK" }, entity_id: { _eq: $entityId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_PROGRAM_STATUS_BY_ID = `
  query GetProgramStatusById($programStatusId: Int!) {
    pep_program_status(where: {program_status_id: {_eq: $programStatusId}}) {
      is_deleted
      program_status_id
      program_status
      created_datetime
    }
    pep_program_status_aggregate {
      aggregate {
        count
      }
    }
  }
`;
